import {
  AfterViewInit,
  Component,
  ElementRef,
  HostListener,
  Input,
  OnInit,
  QueryList,
  ViewChild,
  ViewChildren,
} from '@angular/core';
import {ActivatedRoute, Data, Router} from "@angular/router";
import {animate, state, style, transition, trigger} from "@angular/animations";
import {TranslocoService} from "@ngneat/transloco";
import {AbstractComponent, ConsentComponent, CurrentItemType} from "@components";
import {
  Competitor,
  CompetitorInfoDTO,
  CompetitorRegistrationDto,
  CompetitorRegistrationResultDto,
  Country,
  EventItem,
  EventPaymentType,
  FormFieldError,
  getTeamMemberCount,
  Lookups,
  PaymentStatus,
  Race,
  RaceAdditionalPricingItem,
  RaceCommercialItem,
  RaceRegistrationRequestDto,
  RaceRegistrationResultDto,
  RaceRegResult,
  RegisterHelper,
  RegisterToRaceFormType,
  RegisterToRaceUserType,
  UserDetail,
  WspayConfirmation,
  TOAST_STATE,
} from "@model";
import {
  ActionService,
  AuthenticationService,
  EventService,
  RaceService,
  RegisterToRaceError,
  ToastService,
  WsPayService
} from "@services";
import {RegisterToRaceItemComponent} from "./register-to-race-item/register-to-race-item.component";
import {
  FormArray,
  FormBuilder,
  FormControl,
  FormGroup,
} from "@angular/forms";
import {mergeMap, pairwise, take} from "rxjs/operators";
import {
  LANDING_ROUTE,
  LOGIN_ROUTE,
  ORGANISER_EVENTS_MANAGEMENT,
  PRIVATE_EVENT_CALENDAR_ROUTE,
  REDIRECT_TO_REGISTER_TO_RACE
} from "../../../app-routing.module";
import {NgbModal, NgbModalRef} from "@ng-bootstrap/ng-bootstrap";
import {hasAnyPrice, requiredTrue} from "@utility";
import {EMPTY, of} from "rxjs";

@Component({
    selector: 'app-register-to-race-details',
    templateUrl: './register-to-race.component.html',
    styleUrls: ['./register-to-race.component.scss'],
    animations: [
        trigger('fadeInAnimation', [
            state('in', style({ opacity: 1 })),
            transition(':enter', [
                style({ opacity: 0 }),
                animate(1600)
            ])
        ])
    ],
    standalone: false
})
export class RegisterToRaceComponent extends AbstractComponent implements OnInit, AfterViewInit {
  isAfterViewInitPassed: boolean = false;

  @ViewChildren(RegisterToRaceItemComponent) registerToRaceComponentItems!: QueryList<RegisterToRaceItemComponent>;
  @ViewChildren('racerBlock') racerBlocks!: QueryList<ElementRef<HTMLElement>>;
  @ViewChild('confirmationBlock', { static: false }) confirmationBlock?: ElementRef<HTMLElement>;

  @Input() race: Race | undefined;
  @Input() competitor: Competitor = new Competitor();
  @Input() countries: Country[] = [];
  @Input() currentUserDetails: UserDetail | undefined;
  @Input('raceCommercialItems') raceComItems: RaceCommercialItem[] = [];
  @Input('raceAdditionalItems') raceAddItems: RaceAdditionalPricingItem[] = [];
  @Input() eventCommercialItems: RaceCommercialItem[] = [];
  @Input('sizes') tshirtSizes: Lookups[] = [];
  @Input() meals: Lookups[] = [];
  @Input() transports: Lookups[] = [];
  @Input() genders: Lookups[] = [];
  @Input() currencies: Lookups[] = [];
  @Input() disciplines: Lookups[] = [];
  @Input('eventItem') event: EventItem | undefined;
  @Input({required: true}) languages: Lookups[] = [];
  @Input() isPreviewComponent: boolean = false;
  @Input() isManagement: boolean = false;
  @Input() wspayConfirmation: WspayConfirmation | undefined;

  eventCurrencyLabel: string | undefined;
  registerToRaceUserTypeState: RegisterToRaceUserType = RegisterToRaceUserType.GUEST
  registerToRaceFormType: RegisterToRaceFormType = RegisterToRaceFormType.REGISTRATION_INFO;
  registerForMySelf: boolean = true;
  registerToRaceResponse: RaceRegistrationResultDto | undefined;
  calculationResponse: RaceRegistrationResultDto | undefined;
  isSmallerThanXXL: boolean = false;
  registerHelper: RegisterHelper | undefined;
  registrationWithoutPayment: boolean = false;
  termsAndConditionsAccepted: boolean = false;
  summaryCompetitorItems: CompetitorRegistrationDto[] | CompetitorInfoDTO[] = [];
  showTeamCoupon: boolean = false;

  public currentWindowWidth: number = 0;

  private pendingScrollToConfirmation = false;

  ngAfterViewChecked() {
    if (this.pendingScrollToConfirmation && this.registerToRaceFormType === RegisterToRaceFormType.CONFIRMATION) {
      this.pendingScrollToConfirmation = false;
      this.scrollToConfirmation();
    }
  }

  inputForm = new FormGroup({
    coupons: this.formBuilder.array([]),
    teamCoupon: new FormControl(),
    isActive: new FormControl(false)
  });

  organiserDataForm = new FormGroup({
    registrationPayed: new FormControl(),
  });

  consentForm : FormGroup<{
    termsAndConditionsAccepted: FormControl<boolean | null>;
  }>= new FormGroup({
    termsAndConditionsAccepted: new FormControl(false, [requiredTrue])
  })

  hideTermsAndConditionsCheckbox: boolean = false;

  constructor(private route: ActivatedRoute, private eventService: EventService, public formBuilder: FormBuilder, private raceService: RaceService,
              protected translocoService: TranslocoService, private router: Router, private actionService:ActionService, private wsPayService: WsPayService,
              private toastService: ToastService, public authenticationService: AuthenticationService, private modalService: NgbModal) {
    super();
    if (this.isBrowser) {
      this.checkWindowSize();
    }
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      /// to avoid ExpressionChangedAfterItHasBeenCheckedError with this method in template isApplyTeamCouponButtonDisabled
      this.isAfterViewInitPassed = true;
    });
  }

  ngOnInit(): void {
    this.subscribeToRouteDataChange();
    if (this.wspayConfirmation) {
      if (this.isBrowser) {
        this.registerToRaceFormType = RegisterToRaceFormType.PAYMENT;
        this.setWsPayConfirmationData();
      }
    } else {
      this.registerHelper = new RegisterHelper(this.raceComItems ?? [], this.raceAddItems ?? [], this, this.race?.raceSettings)
      this.registerForMySelf = !this.isManagement && this.route.snapshot.queryParams['registerToRaceForMyself'] !== "false";
      this.meals = this.filterList(this.race?.applicationFormSettings?.meals, this.meals);
      this.tshirtSizes = this.filterList(this.race?.applicationFormSettings?.tshirts, this.tshirtSizes);
      this.disciplines = this.filterList(this.race?.applicationFormSettings?.disciplines, this.disciplines);
      this.initFormType();
      this.filterInputLists();
      if (this.registerHelper.isTeamRegistration()) {
        for (let i = 0; i < (getTeamMemberCount(this.race?.raceSettings?.teamType)); i++) {
          this.addCoupon(i);
          this.inputForm.controls.teamCoupon.valueChanges.subscribe((value: string) => {
            for (let i = 0; i < this.coupons.length; i++) {
              this.coupons.at(i).get('coupon')?.setValue(value);
            }
            this.inputForm.updateValueAndValidity();
          });
        }
      } else {
        this.addCoupon(0);
      }
      this.setDefaultDataForCurrentUser();
    }
    this.setEventCurrencyLabel(this.event?.currency);
    if (this.registerToRaceFormType !== RegisterToRaceFormType.PAYMENT) {
      this.recalculatePrices();
    }
    this.updateSummaryCompetitorItems();
  }

  private subscribeToRouteDataChange(): void {
    this.subscriptions.push(
      this.route.data.subscribe(({isPreview}: Data) => {
        this.isPreviewComponent = isPreview ?? false;
      })
    )
  }

  private setWsPayConfirmationData() {
    if (this.wspayConfirmation) {
      this.event = this.wspayConfirmation.event;
      this.race = this.wspayConfirmation.race;
      this.updateSummaryCompetitorItems();
    }
  }

  @HostListener('window:resize')
  onResize() {
    this.checkWindowSize();
  }

  private checkWindowSize() {
    this.isSmallerThanXXL = window.innerWidth < 1400;
  }

  get raceCommercialItems(): RaceCommercialItem[] {
    return this.registerHelper!.raceCommercialItems;
  }

  get raceAdditionalItems(): RaceAdditionalPricingItem[] {
    return this.registerHelper!.raceAdditionalItems;
  }

  get registrations(): CompetitorRegistrationDto[] {
    return this.registerHelper!.registrations;
  }

  /**
   * Filtered list for id's that organiser has selected in race registration settings
   */
  filterInputLists() {
    if ((this.race?.applicationFormSettings?.meals?.length ?? 0) > 0) {
      this.meals = this.filterList(this.race?.applicationFormSettings?.meals, this.meals);
    }
    if ((this.race?.applicationFormSettings?.tshirts?.length ?? 0) > 0) {
      this.tshirtSizes = this.filterList(this.race?.applicationFormSettings?.tshirts, this.tshirtSizes);
    }
    if ((this.race?.applicationFormSettings?.disciplines?.length ?? 0) > 0) {
      this.disciplines = this.filterList(this.race?.applicationFormSettings?.disciplines, this.disciplines);
    }
  }

  filterList(ids: number[] | undefined, list: Lookups[] | undefined): Lookups[] {
    let filteredItems: Lookups[] = [];
    if ((ids?.length ?? 0) > 0 && (list?.length ?? 0) > 0) {
      for (let item of list!) {
        for (let id of ids!) {
          if (item.id === id) {
            filteredItems.push(item);
          }
        }
      }
    }
    return filteredItems;
  }

  private setDefaultDataForCurrentUser() {
    if (this.currentUserDetails && this.registerToRaceUserTypeState === RegisterToRaceUserType.MEMBER) {
      if (this.currentUserDetails?.birthDay) {
        this.currentUserDetails.birthDay = new Date(this.currentUserDetails.birthDay);
      }
      if (this.currentUserDetails?.identityCardExpires) {
        this.currentUserDetails.identityCardExpires = new Date(this.currentUserDetails.identityCardExpires);
      }
    }
  }

  private initFormType() {
    if (this.isPreviewComponent) {
      this.registerToRaceUserTypeState = RegisterToRaceUserType.PREVIEW;
    }
    else if (this.isManagement) {
      this.registerToRaceUserTypeState = RegisterToRaceUserType.ORGANISER;
      this.organiserDataForm.controls.registrationPayed.setValue(true);
    }
    else {
      if (this.authenticationService.isAuthenticated()) {
        this.registerToRaceUserTypeState = RegisterToRaceUserType.MEMBER;
      } else {
        this.registerToRaceUserTypeState = RegisterToRaceUserType.GUEST;
      }
    }

    this.subscriptions.push(this.consentForm.controls.termsAndConditionsAccepted.valueChanges.subscribe(value => {
      if (value) {
        this.consentForm.controls.termsAndConditionsAccepted.enable({emitEvent:false});
      }
      else {
        this.consentForm.controls.termsAndConditionsAccepted.disable({emitEvent:false});
      }
      this.consentForm.updateValueAndValidity();
    }))

    switch (this.registerToRaceUserTypeState) {
      case RegisterToRaceUserType.MEMBER:
        const termsAndConditionsAccepted: boolean = this.currentUserDetails?.termsAndConditionsAccepted ?? false;
        this.hideTermsAndConditionsCheckbox = termsAndConditionsAccepted;
        this.consentForm.controls.termsAndConditionsAccepted.setValue(termsAndConditionsAccepted);
        break;
      case RegisterToRaceUserType.ORGANISER:
        this.hideTermsAndConditionsCheckbox = false;
        this.consentForm.controls.termsAndConditionsAccepted.setValue(true);
        break;
      default:
        this.hideTermsAndConditionsCheckbox = false;
        this.consentForm.controls.termsAndConditionsAccepted.setValue(false);
        break;
    }
  }

  onContinueWithPayment() {
    if (this.registerToRaceResponse && this.registerToRaceResponse.wsPayForm?.PaymentFormUrl) {
      this.goToWsPay(this.registerToRaceResponse.wsPayForm?.PaymentFormUrl);
    }
  }

  goToWsPay(redirectUrl: string): void {
    window.location.href = redirectUrl;
  }

  confirmRegistration() {
    let allRegistrationItemsAreValid: boolean = true;
    if (!this.consentForm.valid) {
      allRegistrationItemsAreValid = false;
      this.markAllAsTouched(this.consentForm);
    }
    if (this.registerToRaceComponentItems && this.registerToRaceComponentItems.length > 0) {
      for (let i: number = 0; i < this.registerToRaceComponentItems.length; i++) {
        let registerToRaceItem: RegisterToRaceItemComponent | undefined = this.registerToRaceComponentItems.get(i);
        if (!!registerToRaceItem) {
          registerToRaceItem.onRegister();
          if (!registerToRaceItem.inputForm.valid) {
            allRegistrationItemsAreValid = false;
          }
          if (this.registerHelper?.isTeamRegistration() && this.inputForm.controls.teamCoupon.value && this.inputForm.controls.isActive.value && !this.inputForm.controls.teamCoupon.errors) {
            registerToRaceItem.competitorRegistration.couponCode = this.inputForm.controls.teamCoupon.value;
          } else if (!this.coupons.at(i)?.get('coupon')?.errors && this.coupons.at(i)?.get('coupon')?.value && this.coupons.at(i)?.get('isActive')?.value) {
            registerToRaceItem.competitorRegistration.couponCode = this.coupons.at(i).get('coupon')?.value;
          }
          this.registrations[i] = registerToRaceItem.competitorRegistration;
        }
      }
    }
    if (allRegistrationItemsAreValid) {
      this.register();
    }
  }

  register(): void {
    if (!this.isPreviewComponent) {
      let registrationWithoutPayment : boolean = false;
      let raceRegistrationRequestDto: RaceRegistrationRequestDto = new RaceRegistrationRequestDto(this.race?.id, this.registrations);
      if ((!this.registerForMySelf || this.registerHelper?.isTeamRegistration() || this.race?.raceSettings?.enableGroupRegistrationPayment) && this.registrations.length > 0) {
        raceRegistrationRequestDto.receiptEmail = this.registrations[0].receiptEmail;
        this.registrations[0].receiveReceipt = false;
        this.registrations[0].receiptEmail = undefined;
      }
      if (this.registerHelper?.isTeamRegistration()) {
        raceRegistrationRequestDto.teamName = this.registrations[0].teamName;
        raceRegistrationRequestDto.teamCommercialItem = this.registrations[0].raceCommercialItem;
        if (this.inputForm.controls.teamCoupon.value && this.inputForm.controls.isActive.value) {
          raceRegistrationRequestDto.teamCoupon = this.inputForm.controls.teamCoupon.value;
        }
      }
      raceRegistrationRequestDto.termsAndConditionsAccepted = this.consentForm.controls.termsAndConditionsAccepted.value ?? false;

      if (this.isManagement) {
        if (this.organiserDataForm.controls.registrationPayed.value) {
          registrationWithoutPayment = true;
        }
      }

      this.raceService.registerToRace(this.isManagement, raceRegistrationRequestDto, registrationWithoutPayment, (registerToRaceResponse: RaceRegistrationResultDto) => {
        if (registerToRaceResponse.raceRegResult === RaceRegResult.OK) {
          this.registrationWithoutPayment = registrationWithoutPayment;
          this.registerToRaceResponse = registerToRaceResponse;
          this.registerToRaceFormType = RegisterToRaceFormType.CONFIRMATION;
          this.pendingScrollToConfirmation = true;
          if (registerToRaceResponse.assignStartNumberResults && registerToRaceResponse.assignStartNumberResults.length) {
            const startNumberErrors = registerToRaceResponse.assignStartNumberResults
                .map((r, i) => `${ i > 0 ? "<br>" : ""}${r.startNumber} - ${this.translocoService.translate("competitor.edit.error." + r.error)}`)
                .join(",");
            this.toastService.showToast(TOAST_STATE.danger, startNumberErrors);
          }
        } else if (registerToRaceResponse.raceRegResult === RaceRegResult.FORM_VALIDATION_ERROR) {
          const errorFields: string = registerToRaceResponse.competitors?.map((competitor: CompetitorRegistrationResultDto) => {
            return competitor.formFieldErrors?.map((error: FormFieldError) => this.translocoService.translate("app.common." + error.fieldName)).join(", ")
          }).join(", ") ?? "";
          this.toastService.showToast(TOAST_STATE.danger,
            this.translocoService.translate("app.register.to.race.error.form") + " " + errorFields);
        } else {
          this.toastService.showToast(TOAST_STATE.danger,
            this.translocoService.translate("app.register.to.race.error.11"));
        }

      }, (error: RegisterToRaceError) => {
        this.toastService.showToast(TOAST_STATE.danger,
          this.translocoService.translate("app.register.to.race.error." + error));
      });
    } else {
      this.toastService.showToast(TOAST_STATE.success,
        this.translocoService.translate("app.register.to.race.error.preview.warning"))
    }
  }

  goToRegistrationInfo(): void {
    this.registerToRaceFormType = RegisterToRaceFormType.REGISTRATION_INFO
  }

  addNewRacer() {
    let allRegistrationItemsAreValid: boolean = true;
    if (this.registerToRaceComponentItems && this.registerToRaceComponentItems.length > 0) {
      for (let i: number = 0; i < this.registerToRaceComponentItems.length; i++) {
        let raceCommercialItem: RaceCommercialItem | undefined = this.registrations[i].raceCommercialItem;
        let registerToRaceItem: RegisterToRaceItemComponent | undefined = this.registerToRaceComponentItems.get(i);
        if (!!registerToRaceItem) {
          registerToRaceItem.onRegister();
          if (!registerToRaceItem.inputForm.valid) {
            allRegistrationItemsAreValid = false;
            break;
          }
          /// We don't want to overwrite race commercial item in parent component because there is a chance that
          // coupon is already applied
          this.registrations[i] = {...registerToRaceItem.competitorRegistration};
          if (raceCommercialItem) {
            this.registrations[i].raceCommercialItem = raceCommercialItem;
          }
        }
      }
    }
    if (allRegistrationItemsAreValid) {
      this.registerHelper?.addCompetitorRegistration();
      this.addCoupon(this.registrations.length - 1);
      setTimeout(() => {
        const lastRacerEl = this.racerBlocks.toArray()[this.racerBlocks.length - 1]?.nativeElement;
        if (lastRacerEl) {
          const rect = lastRacerEl.getBoundingClientRect();
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          const offsetTop = rect.top + scrollTop - 48;

          window.scrollTo({
            top: offsetTop,
            behavior: 'smooth'
          });
        }
      }, 100);
      this.recalculatePrices();
    }
    this.updateSummaryCompetitorItems();
  }

  onChangeRace(raceId: number) {
    this.router.navigate([this.router.url.split('?')[0]], {
      queryParams: {raceId: raceId},
      queryParamsHandling: "merge",
      replaceUrl: true
    });
  }

  onChangeRegisterToRaceForMyself(registerToRaceForMyself: boolean) {
    this.router.navigate([this.router.url.split('?')[0]], {
      queryParams: {registerToRaceForMyself: registerToRaceForMyself},
      queryParamsHandling: "merge",
      replaceUrl: true
    });
  }

  removeRacer(): void {
    if (this.registrations.length > 1) {
      this.registrations.pop();
      this.removeCoupon(this.registrations.length - 1);
    }
    this.updateSummaryCompetitorItems();
    this.recalculatePrices();
  }

  isAddNewRacerButtonVisible(): boolean {
    return !!(this.race?.raceSettings?.enableGroupRegistrationPayment && this.registrations.length < (this.race?.raceSettings?.maxGroupRegisteredParticipants ?? 0)) && (this.registerHelper?.areAllEmailsUnique() ?? true) && !this.registerHelper?.isTeamRegistration();
  }

  isRemoveNewRacerVisible(index: number): boolean {
    return index === 0 ? false : !!(this.race?.raceSettings?.enableGroupRegistrationPayment && this.registrations.length > 1) && !this.registerHelper?.isTeamRegistration();
  }

  setEventCurrencyLabel(currencyId: number | undefined): void {
    const curr: Lookups | undefined = this.currencies.find((currency) => currency.id === currencyId);
    this.eventCurrencyLabel = curr?.name ?? "EUR";
  }


  get coupons(): FormArray {
    return this.inputForm.controls.coupons as FormArray;
  }

  couponsFormControl(i: number): FormGroup {
    return this.coupons.controls.at(i) as FormGroup;
  }

  private addCoupon(index: number): void {
    let formGroup = this.formBuilder.group({
      coupon: [undefined],
      isActive: [false]
    });
    this.subscriptions.push(formGroup.controls.coupon.valueChanges.pipe(pairwise()).subscribe(([oldValue, newValue]) => {
      if (this.coupons.at(index).get('coupon')?.valid === false && oldValue !== newValue) {
        this.coupons.at(index).get('coupon')?.setValidators([]);
        this.coupons.at(index).get('coupon')?.updateValueAndValidity();
      }
      this.registerHelper!.setDefaultRegistrationFee(index);
      this.registerHelper!.setDefaultAdditionalPricingItems(index);
    }));
    this.coupons.push(formGroup);
    this.inputForm.updateValueAndValidity();
  }

  private removeCoupon(index: number): void {
    this.coupons.removeAt(index);
    this.inputForm.updateValueAndValidity();
  }

  isApplyCouponButtonDisabled(index: number, coupon: string | undefined): boolean {
    let applyCouponButtonDisabled: boolean = true;
    let raceCommercialItemsIsSet: boolean = false;
    let emailIsSet: boolean = false;
    let isEmailUnique: boolean = this.registerHelper!.isEmailUnique(index, this.registrations[index].email ?? '');
    if (this.raceCommercialItems.length === 1) {
      raceCommercialItemsIsSet = true;
    } else if (this.registrations[index].raceCommercialItem) {
      raceCommercialItemsIsSet = true;
    }
    if (raceCommercialItemsIsSet && this.registrations[index].email && this.registrations[index].email !== '') {
      emailIsSet = true;
    }
    if (coupon && coupon !== '' && emailIsSet && isEmailUnique) {
      applyCouponButtonDisabled = false;
    }
    return applyCouponButtonDisabled;
  }

  isApplyTeamCouponButtonDisabled(): boolean {
    let applyTeamCouponButtonDisabled: boolean = false;
    if (this.registerToRaceComponentItems) {
      for (let i = 0; i < this.registerToRaceComponentItems.length; i++) {
        if (this.isApplyCouponButtonDisabled(i, this.inputForm.controls.teamCoupon.value)) {
          applyTeamCouponButtonDisabled = true;
          break;
        }
      }
    }
    return applyTeamCouponButtonDisabled;
  }

  onApplyTeamCoupon() {
    const isActive = !this.inputForm.controls.isActive.value;
    this.inputForm.controls.isActive.setValue(isActive);
    if (isActive) {
      this.inputForm.controls.teamCoupon.disable();
    }
    else {
      this.inputForm.controls.teamCoupon.setValue(undefined);
      this.inputForm.controls.teamCoupon.enable();
    }
    this.recalculatePrices();
  }

  onApplyCoupon(i: number) {
    const isActive = !this.coupons.at(i)?.get('isActive')?.value;
    this.coupons.at(i)?.get('isActive')?.setValue(isActive);
    if (isActive) {
      this.coupons.at(i)?.get('coupon')?.disable();
    }
    else {
      this.coupons.at(i)?.get('coupon')?.enable();
      this.coupons.at(i)?.get('coupon')?.setValue(undefined);
    }
    this.recalculatePrices();
  }


  private calculateRaceItemPrices(raceRegistrationRequestDto: RaceRegistrationRequestDto) {
    this.raceService.calculateRaceItemPrices(raceRegistrationRequestDto, (registerToRaceResponse: RaceRegistrationResultDto) => {
      if (this.registerHelper?.isTeamRegistration()) {
        if (registerToRaceResponse.teamCommercialItemWithDiscount && registerToRaceResponse.teamCommercialItemWithDiscount.couponOK === true && registerToRaceResponse.teamCommercialItemWithDiscount.commercialItem) {
          this.registerHelper!.teamCommercialItemWithDiscount = registerToRaceResponse.teamCommercialItemWithDiscount;
          this.inputForm.controls.teamCoupon.clearValidators();
          for (let item of raceRegistrationRequestDto!.competitorRegistrations!) {
            let index: number | undefined = this.registerHelper?.findIndexByEmail(item.email!);
            if (index !== undefined) {
              let resultItem: any = registerToRaceResponse?.competitors?.find((result) => result.email === item.email);
              if (resultItem && resultItem.commercialItemWithDiscount?.couponOK === true && resultItem.commercialItemWithDiscount.commercialItem) {
                this.registerHelper!.setCalculatedAdditionalPricingItems(index, resultItem.additionalItemsWithDiscount);
              }
            }
          }
        } else {
          this.registerHelper!.teamCommercialItemWithDiscount = undefined;
          this.inputForm.controls.teamCoupon.setErrors({couponInvalid: true});
          this.inputForm.controls.teamCoupon.updateValueAndValidity();
        }
      } else {
        for (let item of raceRegistrationRequestDto!.competitorRegistrations!) {
          let index: number | undefined = this.registerHelper?.findIndexByEmail(item.email!);
          if (index !== undefined) {
            let resultItem = registerToRaceResponse?.competitors?.find((result) => result.email === item.email);
            if (resultItem && resultItem.commercialItemWithDiscount?.couponOK === true && resultItem.commercialItemWithDiscount.commercialItem) {
              this.registerHelper!.setCalculatedRegistrationFee(index, resultItem.commercialItemWithDiscount.commercialItem);
              this.registerHelper!.setCalculatedAdditionalPricingItems(index, resultItem.additionalItemsWithDiscount);
              this.coupons.at(index).get('coupon')?.setErrors(null); // Clear errors without resetting value
            } else {
              this.coupons.at(index).get('coupon')?.setErrors({couponInvalid: true});
              this.coupons.at(index).get('coupon')?.updateValueAndValidity();
            }
          }
        }
      }
      this.calculationResponse = registerToRaceResponse;
    }, () => {
      this.toastService.showToast(TOAST_STATE.danger,
        this.translocoService.translate("app.register.to.race.apply.coupon.error"));
    });
  }

  private extractCompetitorRegistrationDto(index: number, raceRegistrationRequestDto: RaceRegistrationRequestDto, coupon: string | undefined) {
    let item: CompetitorRegistrationDto = this.registrations[index];
    let competitorRegistrationDto: CompetitorRegistrationDto = new CompetitorRegistrationDto();
    competitorRegistrationDto.email = item.email;
    competitorRegistrationDto.couponCode = coupon;
    competitorRegistrationDto.firstName = item.firstName;
    competitorRegistrationDto.lastName = item.lastName;
    competitorRegistrationDto.gender = item.gender;
    competitorRegistrationDto.birthday = item.birthday;
    competitorRegistrationDto.raceCommercialItem = item.raceCommercialItem;
    competitorRegistrationDto.raceAdditionalPricingItems = item.raceAdditionalPricingItems;
    raceRegistrationRequestDto.receiptEmail = item.email;
    return competitorRegistrationDto;
  }

  recalculatePrices() {
    let raceRegistrationRequestDto: RaceRegistrationRequestDto = new RaceRegistrationRequestDto(this.race?.id);
    let competitorRegistrations: CompetitorRegistrationDto[] = [];
    let hasPrice = false;
    this.registrations.forEach((r: CompetitorRegistrationDto, i: number) => {
      competitorRegistrations.push(this.extractCompetitorRegistrationDto(i, r, undefined));
      if (!hasPrice && this.registerHelper?.isTeamRegistration()) {
        hasPrice = hasAnyPrice(r.raceCommercialItem, r.raceAdditionalPricingItems);
      }
    });
    if (this.registerHelper?.isTeamRegistration()) {
      raceRegistrationRequestDto.teamName = this.registrations[0].teamName;
      raceRegistrationRequestDto.teamCommercialItem = this.registrations[0].raceCommercialItem;
      if (this.inputForm.controls.teamCoupon.value && this.inputForm.controls.isActive.value) {
        raceRegistrationRequestDto.teamCoupon = this.inputForm.controls.teamCoupon.value;
        competitorRegistrations.forEach((r: CompetitorRegistrationDto) => {
          r.couponCode = this.inputForm.controls.teamCoupon.value;
        })
      }
      this.showTeamCoupon = hasPrice;
    }
    else {
        competitorRegistrations.forEach((r: CompetitorRegistrationDto, i: number) => {
          if (this.coupons.at(i)?.get('coupon')?.value && this.coupons.at(i)?.get('isActive')?.value) {
            r.couponCode = this.coupons.at(i)?.get('coupon')?.value;
          }
        })
    }
    raceRegistrationRequestDto.competitorRegistrations = competitorRegistrations;
    if ((this.registerHelper?.isTeamRegistration() && raceRegistrationRequestDto.teamCommercialItem) || !this.registerHelper?.isTeamRegistration()) {
      this.calculateRaceItemPrices(raceRegistrationRequestDto);
    }
  }

  openConsentModal(open?: boolean | undefined) {
    if (!this.consentForm.controls.termsAndConditionsAccepted.value || open) {
      const modalRef: NgbModalRef = this.modalService.open(ConsentComponent, {
        centered: true,
        size: 'xl',
        scrollable: true
      });
      modalRef.componentInstance.isProfile = false;
      modalRef.result.then(() => {
        this.consentForm.controls.termsAndConditionsAccepted.setValue(true);
      })
    }
  }

  onClose() {
    if (this.isManagement && this.event?.id) {
      this.eventService.setCurrentEvent(this.event);
      this.router.navigate([ORGANISER_EVENTS_MANAGEMENT], {queryParams: {eventId: this.event!.id!}});
    }
    else {
      this.router.navigate([this.authenticationService.isAuthenticated() ? PRIVATE_EVENT_CALENDAR_ROUTE : LANDING_ROUTE]);
    }
  }

  updateSummaryCompetitorItems() {
    if (
        this.registerToRaceFormType === RegisterToRaceFormType.REGISTRATION_INFO ||
        this.registerToRaceFormType === RegisterToRaceFormType.CONFIRMATION
    ) {
      this.summaryCompetitorItems = (this.registerHelper?.registrations || []).map(item => ({ ...item }));
    } else {
      this.summaryCompetitorItems = (this.wspayConfirmation?.competitors || []).map(item => ({ ...item }));
    }
  }

  onRedirectToLogin() {
    this.actionService.addAction(() => this.router.navigate([REDIRECT_TO_REGISTER_TO_RACE], {
      queryParams: {
        eventId: this.event?.id,
        raceId: this.race?.id
      },
    }));
    this.router.navigate([LOGIN_ROUTE]);
  }

  private scrollToConfirmation() {
    if (this.confirmationBlock) {
      const rect = this.confirmationBlock.nativeElement.getBoundingClientRect();
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const offsetTop = rect.top + scrollTop - 76;

      window.scrollTo({
        top: offsetTop,
        behavior: 'smooth'
      });
    }
  }

  protected readonly RegisterToRaceFormType = RegisterToRaceFormType;
  protected readonly WsPaymentStatus = PaymentStatus;
  protected readonly FormGroup = FormGroup;
  protected readonly Date = Date;
  protected readonly EventPaymentType = EventPaymentType;
  protected readonly CurrentItemType = CurrentItemType;
}

